import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { IModbusDeviceFirmwareVersion } from '../shared/models/models';
import { DeviceBulkOperationDialogData } from '../device-bulk-operation/device-bulk-operation.component';
import { FirmwareVersionService } from '../shared/services/firmware-version.service';

@Component({
    selector: 'dl-device-firmware-update-bulk',
    templateUrl: './device-firmware-update-bulk.component.html'
})
export class DeviceFirmwareUpdateBulkComponent implements OnInit {
    firmwareVersions: IModbusDeviceFirmwareVersion[];
    protected firmwareVersion: string;

    public deviceFirmwareUpdateBulkFormGroup: FormGroup;
    public versionFormControl: FormControl;
    isReady: boolean;

    constructor(
        private matDialogRef: MatDialogRef<DeviceFirmwareUpdateBulkComponent>,
        @Inject(MAT_DIALOG_DATA) private data: DeviceBulkOperationDialogData,
        private firmwareVersionService: FirmwareVersionService
    ) {
    }

    public ngOnInit() {
        this.firmwareVersionService.getList(this.data.hardwareCategory).then(item => {
            this.firmwareVersions = item;

            this.deviceFirmwareUpdateBulkFormGroup = new FormGroup({});
            this.versionFormControl = new FormControl(this.firmwareVersion);
            this.deviceFirmwareUpdateBulkFormGroup.addControl('firmwareVersions', this.versionFormControl);
        });
    }

    public confirm() {
        if (this.firmwareVersion !== null) {
            return this.matDialogRef.close(this.firmwareVersion);
        }
    }

    public cancel() {
        this.matDialogRef.close();
    }

    public updateVersion(change: MatSelectChange) {
        this.firmwareVersion = change.value;
    }
}
